import React, { useContext, useEffect, useState, useRef } from 'react';
import String from '../../../../Assets/Localization/Local';
import { LangContext, CompanyData } from '../../../../App';
import SliderImg1 from '../../../../Assets/Images/Home/aboutar.png'
import SliderImg2 from '../../../../Assets/Images/Home/contactar.png'
import { Row, Col, Container, Button } from 'react-bootstrap'
import './MainHeader.css';
import { Link } from 'react-router-dom'
import { gsap } from "gsap";
import AppStore from '../../../../Assets/Images/App Store.png'
import PlayStore from '../../../../Assets/Images/play-storeIcon.png'
import { API_ENDPOINT } from '../../../../AppConfig';
import axios from 'axios';

const MainHeader = (props) => {

  const [SliderIndex, setIndex] = useState(0);
  const [dataArr, setData] = useState([]);
  const IMGPART = useRef(null)
  const { lang } = useContext(LangContext)
  const { data } = useContext(CompanyData)

  console.log('IMGPARTIMGPART-> ', IMGPART)

  String.setLanguage(lang);

  let tl = gsap.timeline();

  useEffect(() => {

    let uri = `${API_ENDPOINT}/slider?removeLanguage=true`

    axios.get(uri, {
      headers: {
        'Accept-Language': lang
      }
    }).then(response => {
      console.log('response.data.data==> ', response.data.data)
      let Arr = []
      for (let i = 0; i < response.data.data.length; i++) {
        let obj = {}
        obj.id = response.data.data[i].id
        obj.paragraph = response.data.data[i].description
        obj.title = response.data.data[i].title
        obj.img = `${API_ENDPOINT}${response.data.data[i].image}`
        Arr.push(obj)
      }
      setData(Arr)
    }).catch(error => {

    })
  }, [])
  useEffect(() => {
    tl.from('.ImgPart', { duration: 1, opacity: 0, x: lang === "ar" ? -80 : 80 })
      .from('.infoAnim', { duration: 1.5, opacity: 0, y: -80, stagger: 0.4 })
  }, [])

  const nextSlide = () => {
    if (SliderIndex < dataArr.length - 1) {
      setIndex(SliderIndex => SliderIndex + 1)
    }
    else {
      setIndex(0)
    }
    console.log('SliderIndex--> ', SliderIndex, dataArr.length)

    tl.from('.ImgPart', { duration: 1, opacity: 0, x: lang === "ar" ? -50 : 50, delay: 0 })
      .from('.infoAnim', { duration: 1.5, opacity: 0, y: -80, stagger: 0.4 })

  }

  const prevSlide = () => {
    if (SliderIndex > 0) {
      setIndex(SliderIndex => SliderIndex - 1)
    }
    else {
      setIndex(dataArr.length - 1)
    }

    tl.from('.ImgPart', { duration: 1, opacity: 0, x: lang === "ar" ? -50 : 50, delay: 0 })
      .from('.infoAnim', { duration: 1.5, opacity: 0, y: -80, stagger: 0.4 })

    console.log('SliderIndex--> ', SliderIndex, dataArr.length)

  }



  return (
    <div className="MainHeader" style={{ height: props.type === "slider" ? '72vh' : props.type === "word" ? '225px' : '175px', marginBottom: props.type === 'slider' ? '50px' : '' }}>
      {props.type === "word" ?
        <h3>{props.str}</h3>
        :
        props.type === "slider" ?
          <Container fluid className="w-100 h-100 SliderContainer px-5">
            {dataArr.length > 0 &&
              <Row className="w-100 h-100 row">
                <Col xl="6" lg="6" md={window.innerWidth <= 950 ? "12" : "6"} sm="12" xs="12" className="InfoPart">
                  <h1 className="infoAnim" style={{ marginTop: '20%', marginLeft: lang === "en" ? '18%' : '0px', marginRight: lang === "ar" ? '18%' : '0px', textAlign: lang === "ar" ? 'right' : 'left' }}>{dataArr[SliderIndex].title?dataArr[SliderIndex].title[lang]:null}</h1>
                  <p className="infoAnim" style={{ marginLeft: lang === "en" ? '18%' : '0px', marginRight: lang === "ar" ? '18%' : '0px', textAlign: lang === "ar" ? 'right' : 'left' }}>{dataArr[SliderIndex].paragraph?dataArr[SliderIndex].paragraph[lang]:null}</p>
                  <Row className="ShareBtnsInHeader infoAnim m-0 p-0" style={{ left: lang === "en" ? '18%' : '0px', right: lang === "ar" ? '18%' : '0px' }}>
                    <Col lg="6" md="6" xs="6" sm="6" className="p-1 ">
                      <div className="ShareLink ">
                        <a href={data && data.androidUrl} target="_blank" className="ShareLink ">
                          <span ><img src={PlayStore} style={{ paddingLeft: '10px' }} /></span>
                          <span style={{ marginLeft: '11px' }} className="lineStyle">Git It From <b className="word">Playstore</b></span>
                        </a>
                      </div>
                    </Col>
                    <Col lg="6" md="6" xs="6" sm="6" className="p-1 " >
                      <div className="ShareLink ">
                        <a href={data && data.iosUrl} target="_blank" className="ShareLink ">
                          <span ><i className="fab fa-apple fa-2x mx-3"></i></span>
                          <span className="lineStyle" >Git It From <b className="word">Appstore</b></span>
                        </a>
                      </div>
                    </Col>

                  </Row>
                </Col>
                <Col xl="6" lg="6" md="6" sm="0" xs="0" className="ImgPart" style={{ display: window.innerWidth <= 950 ? 'none' : 'block' }}>
                  <img src={dataArr[SliderIndex].img} />
                </Col>
              </Row>
            }
            {dataArr.length > 0 &&
              <div className="SliderArrows">
                <Link onClick={nextSlide}><i className="fas fa-chevron-right fa-3x nextArrow"></i></Link>
                <Link onClick={prevSlide}><i className="fas fa-chevron-left fa-3x prevArrow"></i></Link>
              </div>
            }
          </Container>
          : null
      }
      {/* <div className="wave" style={{ height: props.type === "slider" ? '11%' : '31%' }}></div> */}
    </div>
  );
}

export default MainHeader;
